import { ELEMENT_GESTURE_MOVABLE_CONTAINER } from '@components/ArtBoard/Canvas/hooks/events/useDragEvents'
import type { ID } from '@octopus-do/octopus-project-core'
import { buildCanvasEvent } from '@store/globalSaga/sagas/updateCanvas/utils'
import { migrationProjectSelector } from '@store/migrationSelectors/projectSelectors'
import { select } from 'redux-saga/effects'

import type { GlobalActions } from '@/store'

type Action = ReturnType<typeof GlobalActions.updateCanvas>

export function* updateCanvas({ payload }: Action) {
  const ref = document.getElementById(ELEMENT_GESTURE_MOVABLE_CONTAINER)

  const activeTab: ID = yield select(
    migrationProjectSelector.getActiveOrFirstTabId
  )

  const ev = buildCanvasEvent(ref, payload, activeTab)
  if (!ev) {
    return
  }

  window.dispatchEvent(ev)
}
